export const teal700 = '#00796B';
export const teal500 = '#009688';
export const teal300 = '#B2DFDB';



/** WEBPACK FOOTER **
 ** ./colors.js
 **/